import { AllSelection, NodeSelection } from 'prosemirror-state'
import { EditorView } from 'prosemirror-view'

export const elementFromSelection = (view: EditorView) => {
  const {
    state: { selection },
  } = view
  if (selection instanceof NodeSelection) {
    return view.nodeDOM(selection.from) as HTMLElement | undefined
  }
  if (selection instanceof AllSelection) {
    let element = view.domAtPos(selection.head).node as HTMLElement | undefined
    if (element?.nodeName === '#text') element = element.parentElement as HTMLElement
    return element
  }
}
